<template>
    <b-card>
        <h3 v-if="!listener.isNew()">{{ listener.$.name }}</h3>
        <h3 v-if="listener.isNew()">New listener</h3>
        <b-form-group>
            <b-input-group>
                <b-form-input
                    type="text"
                    placeholder="Listener name"
                    v-model="listener.name"
                />
                <b-btn
                    @click="disableListener()"
                    v-if="listener.enabled"
                    variant="success"
                    slot="append"
                    >Enabled</b-btn
                >
                <b-btn
                    @click="enableListener()"
                    v-if="!listener.enabled"
                    variant="danger"
                    slot="append"
                    >Disabled</b-btn
                > </b-input-group
            ><br />
            <b-form-textarea
                placeholder="Description"
                rows="3"
                v-model="listener.description"
            >
            </b-form-textarea>
            <hr />
        </b-form-group>
        <b-form-group>
            <label>Which model/entity does this listener apply to?</label>

            <b-input-group style="widht:50%">
                <b-form-input
                    type="text"
                    placeholder="Entity\Namespace"
                    v-model="listener.entity"
                />
                <b-btn slot="append" disabled>@</b-btn>
                <div slot="append">
                    <b-form-select
                        :options="getAvailableEvents()"
                        v-model="listener.event"
                    ></b-form-select>
                </div>
            </b-input-group>
        </b-form-group>
        <b-form-group>
            <label>Resolve relationships from entity:</label>
            <b-input v-model="listener.resolve_relationships" />
            <p class="small">Case sensitive and commasepareted!</p>
        </b-form-group>
        <b-form-group>
            <label>Actions</label>
            <b-form-input
                type="text"
                placeholder="URL"
                v-model="listener.actions"
            />
            <p class="small">
                For the sake of simplicity we only have one action right now. A
                feature version will include the opportunity for using different
                handlers (email, http etc) and criteria ++.
            </p>
        </b-form-group>
        <b-form-group>
            <b-button
                type="submit"
                size="sm"
                variant="success"
                :disabled="!listener.changed() || listener.saving"
                @click="listener.save()"
            >
                <i class="fa fa-dot-circle-o" v-if="!listener.saving"></i>
                <i class="fa fa-spinner fa-spin" v-if="listener.saving"></i>
                Save
            </b-button>
            &nbsp;
        </b-form-group>
    </b-card>
</template>

<script>
export default {
    name: 'EntityEventListener',
    props: {
        listener: {
            required: true,
            validator: () => {
                return true
            },
        },
    },

    components: {},

    created() {},

    methods: {
        enableListener() {
            this.listener.enabled = true
            this.listener.save()
        },

        getAvailableEvents() {
            return ['created', 'updated', 'deleted', 'restored']
        },

        disableListener() {
            this.listener.enabled = false
            this.listener.save()
        },
    },
}
</script>

<style></style>
